/**
 * @module AppModule
 * @description
 * Base module of the application
 */

// import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';


import { DatePipe } from '@angular/common';

// Importing App Component
import { AppComponent } from './app.component';

// Importing modules
import { CoreModule } from '@core/core.module';
import { AppThemeModule } from '@app/modules/theme/app-theme.module';
import { AppRoutingModule } from '@app/app-routing.module';
import { MatNativeDateModule } from '@angular/material/core';
import { environment } from '@environment/environment';
import { FacebookModule } from 'ngx-facebook';
import { NavigationEnd, Router } from '@angular/router';
import { INSTANCE_SESSION } from './configs/app-settings.config';
import { isWebWorkerExist, winReload } from './core/helpers/utils';
import LogRocket from 'logrocket';
import { EnvironmentEnum } from './core/helpers/enums/enums';
import { CommonService } from './core/services/common.service';
import { RecIndexDbService } from './core/services/index-db/rec-index-db.service';




@NgModule({
  declarations: [
    AppComponent,


  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    AppThemeModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    FacebookModule.forRoot(),
    // ChartsModule
  ],
  providers: [
    // {
    //   provide: TYPES.WEB_RTC_SERVICE,
    //   useClass: dolbyWebRtcService
    // },
    DatePipe,
    //{ provide: ErrorHandler, useClass: SentryErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private router: Router,
    private commonService: CommonService,
    private readonly recIndexDbService: RecIndexDbService,
  ) {
    this.spawnWebWorker();
    this.routerEvent();
    LogRocket.init(environment.logRocket);
  }

  /**
   * listen to the navigation events
   */
  routerEvent() {
    this.router.events.subscribe((event: any): void => {
      if (event instanceof NavigationEnd) {
        if (window[INSTANCE_SESSION]) {
          winReload();
        }
        ////this.refreshToken(event.url);
      }
    });
  }

  /**
   * handle refresh token of the application on core level
   * @param url 
   */
  refreshToken(url: String) {
    try {
      let isPathNotAllow = ["login"].some(x => url.includes(x));
      if (!isPathNotAllow) {
        this.commonService.refreshTokenHandler();
      }
    } catch (error) {
      console.error('refreshToken', error)
    }
  }

  /**
   * spawn web worker for managing threads
   */
  async spawnWebWorker() {
    try {
      await this.recIndexDbService.init();
      const path = location.pathname;
      const isAllowedPathForWorker = (path: string) => {
        return path.includes('session/room')
      }
      if (isAllowedPathForWorker(path)) {
        const isWebWorker = isWebWorkerExist();
        if (isWebWorker) {
          console.log('worker spawned')
          const worker = new Worker('./core/web-worker/app.worker', { type: 'module' });
          worker.onmessage = ({ data }) => {
            console.log(`worker is started:  ${data}`);
          };
          worker.postMessage({
            type: 'start-uploader',
            data: {
              page: path
            }
          });
        }
      }
    } catch (error) {
      console.error('spawnWebWorker', error)
    }
  }

}
